import { ataService } from '@/services/ata/ata-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaDocumentQuery = (
  projectId: MaybeRefOrGetter<string>,
  ataId: MaybeRefOrGetter<string>,
) => {
  return useQuery({
    queryKey: computed(() =>
      projectKeys.ataDocument({
        projectId: toValue(projectId),
        ataId: toValue(ataId),
      }),
    ),
    queryFn: () => ataService.getDocument(toValue(projectId), toValue(ataId)),
    enabled: computed(() => toValue(ataId) !== '0'),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
